import React from 'react';
import { Label } from '@/components/ui/label';
import { Music, Eye, EyeOff } from 'lucide-react';

interface SongCardHeaderProps {
  publisert: boolean;
  onPublisertToggle: () => void;
}

export const SongCardHeader: React.FC<SongCardHeaderProps> = ({
  publisert,
  onPublisertToggle,
}) => {
  return (
    <div className="flex items-start justify-between gap-3 mb-6">
      <div className="flex items-start gap-3">
        <div className="p-2 bg-primary/10 rounded-lg">
          <Music className="h-5 w-5 text-primary" />
        </div>
        <div>
          <h2 className="text-xl font-semibold">Grunnleggende informasjon</h2>
          <p className="text-sm text-muted-foreground">Fyll ut detaljer om sangen</p>
        </div>
      </div>
      
      {/* Publisert Toggle */}
      <div className="flex items-center gap-2 flex-shrink-0">
        <Label htmlFor="publisert" className="text-sm">Publisert</Label>
        <button
          type="button"
          id="publisert"
          onClick={onPublisertToggle}
          className={`
            relative inline-flex h-6 w-11 items-center rounded-full transition-colors
            ${publisert ? 'bg-primary' : 'bg-gray-300'}
          `}
          role="switch"
          aria-checked={publisert}
        >
          <span className="sr-only">Publisert</span>
          <span
            className={`
              inline-flex h-5 w-5 items-center justify-center transform rounded-full bg-white shadow-sm transition-transform
              ${publisert ? 'translate-x-5' : 'translate-x-0.5'}
            `}
          >
            {publisert ? (
              <Eye className="h-3 w-3 text-primary" />
            ) : (
              <EyeOff className="h-3 w-3 text-gray-500" />
            )}
          </span>
        </button>
      </div>
    </div>
  );
};

